<script>

    import { replace } from 'svelte-spa-router'
    import { userStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import Tabs from '../$components/tabs.svelte'
    import Button from '../$components/button.svelte'

    import ModalsUsers from './modals.users.svelte'

    import User from './component.user.svelte'
    import UserProviders from './component.providers.svelte'

    import Accounts from '../accounts/component.accounts.svelte'
    import Charges from '../charges/component.charges.svelte'
    import Credits from '../credits/component.credits.svelte'
    import Prepaids from '../prepaids/component.prepaids.svelte'
    import Prices from '../prices/component.prices.svelte'
    import Wallet from '../wallets/component.wallet.svelte'
    import Notifications from '../notifications/component.notifications.svelte'
    import Notices from '../notices/component.notices.svelte'
    import Invoices from '../facturama/view.invoices.svelte'

    let menuSelected = 'user'

    if(!$userStore)
        replace('#/users')

    const menu = []

    if(isPermission($adminStore, 'UsersView.User.View'))
        menu.push({key: 'user', name:'Usuario', icon: 'user'})

    if(isPermission($adminStore, 'UsersView.Wallet.View'))
        menu.push({key: 'wallet', name:'Cartera', icon: 'wallet'})

    if(isPermission($adminStore, 'UsersView.Credits.View'))
        menu.push({key: 'credits', name: 'Créditos', icon: 'credit-card'})

    if(isPermission($adminStore, 'UsersView.Charges.View'))
        menu.push({key: 'charges', name: 'Cargos y Reembolsos', icon: 'file-invoice-dollar'})

    if(isPermission($adminStore, 'UsersView.Prices.View'))
        menu.push({key: 'prices', name:'Precios', icon: 'money-check-alt'})

    if(isPermission($adminStore, 'UsersView.Accounts.View'))
        menu.push({key: 'accounts', name:'Cuentas', icon: 'file-invoice-dollar'})

    if(isPermission($adminStore, 'UsersView.Invoices.View'))
        menu.push({key: 'invoices', name:'Facturas', icon: 'file-invoice'})

    if(isPermission($adminStore, 'UsersView.Providers.View'))
        menu.push({key: 'providers', name:'Proveedores', icon: 'truck'})

    if(isPermission($adminStore, 'UsersView.Notifications.View'))
        menu.push({key: 'notifications', name:'Notificaciones', icon: 'bell'})

    if(isPermission($adminStore, 'UsersView.Notices.View'))
        menu.push({key: 'notices', name:'Avisos', icon: 'sticky-note'})

    let tabPricing = 'prices'
    const tabPricingOptions = []

    if(isPermission($adminStore, 'UsersView.Prices.View'))
        tabPricingOptions.push({key: 'prices', name: 'Precios', icon: 'award'})

    if(isPermission($adminStore, 'UsersView.Prepaids.View'))
        tabPricingOptions.push({key: 'prepaids', name: 'Prepagos', icon: 'shopping-cart'})

    $: notificationsQuery = {
        type: 'user',
        userId: $userStore?._id,
    }

    $: noticesQuery = {
        userId: $userStore?._id,
    }

</script>

<ModalsUsers/>

{#if $userStore}
    <div class="items-end">
        <Button on:click={() => userStore.set(null)} text="Cerrar" icon="times" color="primary" />
    </div>

    <div class="user-info-header">
        <div class="title">{ $userStore.name }</div>
        <div class="subtitle">{ $userStore.email }</div>
    </div>

    <div class="columns user-info-layout">
        <div class="column is-2 user-info-menu-column">
            <aside class="menu user-info-menu">
                <ul class="menu-list">
                    {#each menu as option}
                        <li>
                            <button
                                type="button"
                                class="user-info-menu-item"
                                class:is-active={menuSelected === option.key}
                                on:click={() => menuSelected = option.key}
                            >
                                {#if option.icon}
                                    <span class="icon"><i class="fas fa-{option.icon}"></i></span>
                                {/if}
                                <span>{option.name}</span>
                            </button>
                        </li>
                    {/each}
                </ul>
            </aside>
        </div>

        <div class="column is-10 user-info-content-column">
            {#if menuSelected === 'user'}
                <User />
            {:else if menuSelected === 'wallet'}
                <Wallet />
            {:else if menuSelected === 'credits'}
                <Credits />
            {:else if menuSelected === 'charges'}
                <Charges />
            {:else if menuSelected === 'prices'}
                <div class="user-info-subsection">
                    {#if tabPricingOptions.length > 1}
                        <Tabs bind:selected={tabPricing} options={tabPricingOptions} />
                    {/if}

                    {#if tabPricing === 'prices'}
                        <Prices query={{ userId: $userStore._id, all: false }} />
                    {:else if tabPricing === 'prepaids'}
                        <Prepaids />
                    {/if}
                </div>
            {:else if menuSelected === 'accounts'}
                <Accounts />
            {:else if menuSelected === 'invoices'}
                <Invoices />
            {:else if menuSelected === 'providers'}
                <UserProviders />
            {:else if menuSelected === 'notifications'}
                <Notifications query={notificationsQuery} />
            {:else if menuSelected === 'notices'}
                <Notices query={noticesQuery} />
            {/if}
        </div>
    </div>
{/if}

<style>
    .user-info-header {
        margin-bottom: 0.25rem;
    }

    .user-info-header .title {
        margin-bottom: 0.25rem;
    }

    .user-info-subsection {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .user-info-layout {
        margin-top: 1rem;
    }

    .user-info-menu-column {
        min-width: 180px;
    }

    .user-info-menu-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border: 0;
        border-radius: 6px;
        background: transparent;
        padding: 0.65rem 0.75rem;
        cursor: pointer;
        color: inherit;
        text-align: left;
        font-size: 0.9rem;
    }

    .user-info-menu-item:hover {
        background: rgba(127, 127, 127, 0.12);
    }

    .user-info-menu-item.is-active {
        background: rgba(9, 142, 55, 0.12);
        color: var(--color-primary, #098E37);
        font-weight: 600;
    }

    .user-info-content-column {
        min-width: 0;
    }

    .user-info-content-column :global(.premium-table-wrapper:first-child) {
        margin-top: 0;
    }

    @media screen and (max-width: 768px) {
        .user-info-layout {
            margin-top: 0.75rem;
        }

        .user-info-menu-column {
            min-width: 100%;
            margin-bottom: 0.5rem;
        }

        .user-info-menu .menu-list {
            display: flex;
            gap: 0.5rem;
            overflow-x: auto;
            padding-bottom: 0.25rem;
            margin: 0;
            -webkit-overflow-scrolling: touch;
        }

        .user-info-menu .menu-list li {
            flex: 0 0 auto;
        }

        .user-info-menu-item {
            width: auto;
            white-space: nowrap;
            padding: 0.5rem 0.65rem;
            border: 1px solid rgba(127, 127, 127, 0.2);
        }

        .user-info-content-column {
            margin-top: 0.25rem;
        }
    }
</style>
